import React from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import SelectImg from '../../assets/select_img.svg';

const useStyles = makeStyles(() =>
    createStyles({
        hiddenInput: {
            display: 'none',
        },
        imageUploadCard: {
            display: 'flex',
            position: 'relative',
            marginTop: 5,
            width: '20%',
        },
        absoluteLabel: {
            position: 'absolute',
            top: 0,
            right: 0,
            transform: 'translate(-50%, -50%)',
        },
        profileImage: {
            width: 112,
            height: 112,
        },
        iconbox: {
            height: 10,
            marginLeft: 5,
        },
    }),
);

interface Props {
    img: string | undefined;
    handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function StaffRegisterImageForm(props: Props): React.ReactElement {
    const { img, handleFileChange } = props;
    const classes = useStyles();

    return (
        <div className={classes.imageUploadCard}>
            <img className={classes.profileImage} src={img} />
            <input
                accept='image/*'
                className={classes.hiddenInput}
                id='profile_image'
                type='file'
                onChange={handleFileChange}
            />
            <label htmlFor='profile_image' className={classes.iconbox}>
                <img src={SelectImg} />
            </label>
        </div>
    );
}

export default StaffRegisterImageForm;
